import './CSS/footer.css'

function Footer() {

    return(
        <footer className="footerContainer">
        {/* <div className="section">Left Section</div>
        <div className="section">Middle Section</div>
        <div className="section">Right Section</div> */}
        </footer>
    )
}

export default Footer